/* eslint-disable eqeqeq */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import ApiUtils from 'api/ApiUtils';
import React, {useEffect, useState} from 'react';
import {Button, Col, Form, Row} from 'react-bootstrap';
import {
  type EventFormProps,
  type CategoryDetailsTypes,
  type CategoryStatusList,
} from 'utils/TypeConfig';
import {useFormik} from 'formik';

import * as Yup from 'yup';
import {toast} from 'react-toastify';
import TooltipWithInfoIcon from 'Common/InfoTool';
import {tooltipMessage} from 'utils/Tooltips';
import {renderCategoryOptions} from 'helpers/CategoryOption';
import {variables} from 'utils/constant';
import moment from 'moment';
import Select, {type MultiValue} from 'react-select';
import FileUploader from 'Common/FileUploader';
import {useDispatch, useSelector} from 'react-redux';
import customStyles from 'Common/customStyles';
import {setCountryCode} from 'slices/common/reducer';
import {type AppDispatch} from 'store';
import phone from 'phone';

interface UploadedFile {
  image: File;
  preview: string;
  type: 'image' | 'video';
}
interface UploadedFileNew {
  image: File;
  preview: string;
  type: 'image' | 'video' | 'delete';
  image_name: string;
}

interface Club {
  id: number;
  name: string;
}
const EventForm: React.FC<EventFormProps> = ({
  handleClose,
  setIsEditCategory,
  setIsAddCategory,
  editEvent,
}) => {
  const dispatch = useDispatch<AppDispatch>();
  const [status] = useState([
    {id: variables.EVENT_ACTIVE_STATUS_ID, name: variables.EVENT_ACTIVE_STATUS},
    {
      id: variables.EVENT_INACTIVE_STATUS_ID,
      name: variables.EVENT_INACTIVE_STATUS,
    },
  ]);

  const guestListStatus = [
    {id: variables.EVENT_ACTIVE_STATUS_ID, name: variables.EVENT_ACTIVE_STATUS},
    {
      id: variables.EVENT_INACTIVE_STATUS_ID,
      name: variables.EVENT_INACTIVE_STATUS,
    },
  ];
  const {Layout}: any = useSelector(state => state);
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    if (Layout.layoutModeType === 'dark') {
      setIsDark(true);
    } else if (Layout.layoutModeType === 'light') {
      setIsDark(false);
    } else {
      setIsDark(false);
    }
  }, [Layout.layoutModeType]);

  const [selectedOptions, setSelectedOptions] = useState<any>([]);

  // console.log('🚀 ~ selectedOptions:', selectedOptions);

  const [options, setOption] = useState<any>([]);
  const [commissionStructure, setCommissionStructure] = useState<any>(null);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [uploadedFiles, setUploadedFiles] = useState<UploadedFile[]>([]);
  // console.log('🚀 ~ uploadedFiles:', uploadedFiles);

  const handleFilesAdded = (files: UploadedFile[]): void => {
    // console.log('🚀 ~ handleFilesAdded ~ files:', [...files]);
    setUploadedFiles(files);

    // validation.setFieldValue('files', [...files]);
    files.map((file: any) => {
      // eslint-disable-next-line no-void
      return void replaceImageWithCropped(file);
    });
    // Check if the files array is empty or contains only "delete" type items
    const hasDeleteType = files.every((file: any) => file.type === 'delete');

    // If all files are of type "delete" or the files array is empty, set the Formik field to empty
    if (files.length === 0 || hasDeleteType) {
      validation.setFieldValue('files', []);
    } else {
      // Otherwise, set the Formik field to the new files
      setUploadedFiles(files);
      validation.setFieldValue('files', [...files]);
    }
  };

  const replaceImageWithCropped = async (data: {
    fileName: string;
    croppedPreview: RequestInfo | URL;
    image: File;
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  }) => {
    if (data.croppedPreview) {
      try {
        // Fetch the croppedPreview blob
        const response = await fetch(data.croppedPreview);
        const blob = await response.blob();

        // Create a new File object from the blob
        const croppedImageFile = new File([blob], data?.fileName, {
          type: blob.type,
        });

        // Replace the image with the cropped file
        data.image = croppedImageFile;
      } catch (error) {
        console.error('Error replacing image with cropped preview:', error);
      }
    } else {
      console.warn('No croppedPreview available to replace the image.');
    }
  };

  useEffect(() => {
    // Define the async function for fetching data
    const fetchDressCodeList = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.getDressCodeList(); // Ensure parentheses
        const mapData = response?.data?.map((option: any) => {
          return {
            value: option.id,
            label: option.name,
          };
        });

        setOption(mapData || []); // Update state with fetched data
      } catch (error) {
        console.error('Error fetching dress code list:', error);
      }
    };
    void fetchDressCodeList();
  }, []);

  const handleSelectDressCodeChange = (
    selectedOptions: MultiValue<{value: string; label: string}>,
  ): void => {
    setSelectedOptions([...selectedOptions]); // Convert read-only array to mutable array
    validation.setFieldValue('dress_code_id', [...selectedOptions]);
  };

  const [categoryList, setCategoryList] = useState([]);
  const [type, setType] = useState(
    editEvent?.club_profile_id ? 1 : editEvent?.restaurant_profile_id ? 2 : '',
  );
  // const [fileDisplay, setFileDisplay] = useState<string>();

  const mappedDressCode = editEvent?.event_dress_code?.map(
    (eventDress: any) => {
      return {
        value: eventDress?.dress_code_id,
        label: eventDress?.dress_code_name,
      };
    },
  );

  useEffect(() => {
    setSelectedOptions(mappedDressCode);
    setCommissionStructure(editEvent?.commission_structure ?? null);
  }, []);

  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      event_name: editEvent?.event_name !== '' ? editEvent?.event_name : '',
      main_artist_name:
        editEvent?.main_artist_name !== '' ? editEvent?.main_artist_name : '',
      other_artist_name:
        editEvent?.other_artist_name !== '' ? editEvent?.other_artist_name : '',
      table_booking_recipient_country_id:
        editEvent?.country_code !== '' ? editEvent?.country_code : '',
      table_booking_recipient:
        editEvent?.table_booking_recipient !== ''
          ? editEvent?.table_booking_recipient
          : '',
      country_code: editEvent?.table_booking_recipient_country_id || '229', // Default ID for +971
      venue_id: editEvent?.venue_id !== '' ? editEvent?.venue_id : null,
      address: editEvent?.address !== '' ? editEvent?.address : '',
      description: editEvent?.description !== '' ? editEvent?.description : '',
      date_time: editEvent?.date_time !== '' ? editEvent?.date_time : '',
      end_date: editEvent?.end_date !== '' ? editEvent?.end_date : '',
      guest_close_date_time:
        editEvent?.guest_close_date_time !== ''
          ? editEvent?.guest_close_date_time
          : '',
      selectedOptions:
        editEvent?.selectedOptions?.length !== 0
          ? editEvent?.selectedOptions
          : [],
      dress_code_id:
        editEvent?.event_dress_code?.length !== 0 ? mappedDressCode : [],
      // file: editEvent?.file !== '' ? editEvent?.file : undefined,
      status: editEvent?.status !== '' ? editEvent?.status : '',
      guest_status:
        editEvent?.guest_status !== '' ? editEvent?.guest_status : '',
      age_policy: editEvent?.age_policy !== '' ? editEvent?.age_policy : '',
      files: editEvent?.event_image?.length > 0 ? editEvent?.event_image : [],
      max_capacity:
        editEvent?.guest_max_capacity !== ''
          ? editEvent?.guest_max_capacity
          : '',
      priority_entry_rules:
        editEvent?.priority_entry_rules !== ''
          ? editEvent?.priority_entry_rules
          : '',
      booking_status:
        editEvent?.booking_status !== '' ? editEvent?.booking_status : '',
      weekday_discount:
        editEvent?.weekday_discount !== '' ? editEvent?.weekday_discount : '',
      weekend_discount:
        editEvent?.weekend_discount !== '' ? editEvent?.weekend_discount : '',
      type: editEvent?.type !== '' ? editEvent?.type : '',
      table_max_capacity:
        editEvent?.table_max_capacity !== ''
          ? editEvent?.table_max_capacity
          : '',
      type_data:
        editEvent?.club_profile_id !== null &&
        editEvent?.club_profile_id !== undefined
          ? 1
          : editEvent?.restaurant_profile_id !== null &&
              editEvent?.restaurant_profile_id !== undefined
            ? 2
            : '',
      club_restaurant:
        editEvent?.club_profile_id !== null &&
        editEvent?.club_profile_id !== undefined
          ? editEvent?.club_profile_id
          : editEvent?.restaurant_profile_id !== null &&
              editEvent?.restaurant_profile_id !== undefined
            ? editEvent?.restaurant_profile_id
            : '',
    },
    validationSchema: Yup.object({
      type_data: Yup.string().required('Type is required'),
      club_restaurant: Yup.string().required(`Club/Restaurant is required`),
      event_name: Yup.string().required('Event name is required'),
      venue_id: Yup.string().required('Venue is required'),
      address: Yup.string()
        .required('Address is required')
        .max(250, 'Address cannot exceed 250 characters'),
      description: Yup.string()
        .max(250, 'Description cannot exceed 250 characters')
        .nullable(),
      // file: Yup.mixed().required('Image is required'),
      table_booking_recipient: Yup.lazy((value: any, {parent}: any): any => {
        console.log('🚀 ~ table_booking_recipient:Yup.lazy ~ parent:', parent);
        if (parent.booking_status == 1) {
          console.log('1111111111111111111', parent?.booking_status);
          return Yup.string()
            .required('Table booking recipient is required')
            .test(
              'custom-phone-validation',
              'Phone number is invalid.',
              function (value) {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                const {
                  // eslint-disable-next-line @typescript-eslint/naming-convention
                  selected_country_code,
                  // eslint-disable-next-line @typescript-eslint/naming-convention
                  selected_country,
                  // eslint-disable-next-line @typescript-eslint/naming-convention
                  table_booking_recipient,
                }: any = this.parent;
                if (!value) return false; // Ensure value exists
                return customFunction(
                  table_booking_recipient,
                  selected_country_code ?? selected_country?.country_code,
                );
              },
            );
        }
        return Yup.string().nullable();
        // console.log('2222222');
        // return Yup.string()
        //   .nullable()
        //   .test(
        //     'custom-phone-validation',
        //     'Phone number is invalid.',
        //     function (value) {
        //       // eslint-disable-next-line @typescript-eslint/naming-convention
        //       const {selected_country_code} = this.parent;
        //       if (!value) return true; // Allow nullable values
        //       return customFunction(value, selected_country_code);
        //     },
        //   );
      }),

      date_time: Yup.string().required('Date & time is required'),
      dress_code_id: Yup.array().of(
        Yup.object().shape({
          value: Yup.string().required(),
          label: Yup.string().required(),
        }),
      ),
      // .min(1, 'At least one value must be selected.'),
      // .required('Dress Code is required.'),
      end_date: Yup.string()
        .required('End date & time is required')
        .test(
          'is-after-date-time',
          'End date & time must be after Event Date & time',
          function (value) {
            if (!value || !this.parent.date_time) return true; // Skip validation if values are missing

            // Format both dates to exclude seconds
            const formattedEndDate = moment(value).format('YYYY-MM-DD HH:mm');
            const formattedDateTime = moment(this.parent.date_time).format(
              'YYYY-MM-DD HH:mm',
            );

            // Compare the two formatted dates
            return moment(formattedEndDate, 'YYYY-MM-DD HH:mm').isAfter(
              moment(formattedDateTime, 'YYYY-MM-DD HH:mm'),
            );
          },
        ),
      status: Yup.number().typeError('').required('Status is required'),
      guest_status: Yup.number()
        .typeError('')
        .required('Guest status is required'),

      guest_close_date_time: Yup.lazy((value, {parent}) => {
        if (parent.guest_status === 1) {
          // If guest_status is 1, validate guest_close_date_time
          return Yup.string()
            .required('Guest close date & time is required')
            .test(
              'is-before-date-time',
              'Guest close date & time must be earlier than Event End Date & time',
              function (value) {
                if (!value || !this.parent.end_date) return true;
                return moment(value).isBefore(moment(this.parent.end_date));
              },
            );
        }
        // Otherwise, allow it to be nullable
        return Yup.string().nullable();
      }),

      max_capacity: Yup.lazy((value, {parent}) => {
        if (parent.guest_status === 1) {
          // If guest_status is 1, validate max_capacity
          return Yup.number()
            .required('Guest max capacity is required')
            .min(
              1,
              'Guest max capacity must be a positive number and greater than 0',
            ); // Ensure non-negative value
        }
        // Otherwise, allow it to be nullable
        return Yup.number().nullable();
      }),
      priority_entry_rules: Yup.lazy((value, {parent}) => {
        // if (parent.guest_status === 1) {
        //   // If guest_status is 1, validate priority_entry_rules
        //   return Yup.string().required('Priority entry rules is required');
        // }
        // Otherwise, allow it to be nullable
        return Yup.string().nullable();
      }),
      booking_status: Yup.number()
        .typeError('')
        .required('Booking status is required'),

      weekday_discount: Yup.lazy((value, {parent}) => {
        if (parent.booking_status === 1) {
          // If booking_status is 1, validate weekday_discount
          return Yup.number()
            .nullable()
            .min(0, 'weekday discount must be a positive number'); // Ensure non-negative value;
        }
        // Otherwise, allow it to be nullable
        return Yup.number().nullable();
      }),
      weekend_discount: Yup.lazy((value, {parent}) => {
        if (parent.booking_status === 1) {
          // If booking_status is 1, validate weekend_discount
          return Yup.number()
            .nullable()
            .min(0, 'weekend discount must be a positive number');
        }
        // Otherwise, allow it to be nullable
        return Yup.number().nullable();
      }),
      table_max_capacity: Yup.lazy((value, {parent}) => {
        if (parent.booking_status === 1) {
          // If guest_status is 1, validate table max_capacity
          return Yup.number()
            .required('Table max capacity is required')
            .min(
              4,
              'Table max capacity must be a positive number and minimum 4',
            ); // Ensure non-negative value
        }
        // Otherwise, allow it to be nullable
        return Yup.number().nullable();
      }),

      // files: Yup.array()
      //   .of(
      //     Yup.mixed<UploadedFileNew>()
      //       .required('File is required')
      //       .test(
      //         'fileDimensions',
      //         'Each file must have dimensions of 1080x1080.',
      //         async (file: UploadedFileNew, context) => {
      //           // Track if any file has invalid dimensions
      //           let isInvalid = false;
      //           if (file?.image_name !== undefined) {
      //             isInvalid = false;
      //             return true;
      //           } else {
      //             if (!file?.image || !(file.image instanceof File)) {
      //               return false; // Invalid file structure or missing required properties
      //             }

      //             const objectUrl = URL.createObjectURL(file.image);

      //             // Check dimensions of the image/video
      //             const checkDimensions = new Promise<boolean>(resolve => {
      //               if (file.type === 'image') {
      //                 const img = new Image();
      //                 console.log('🚀 ~ checkDimensions ~ img:', img);
      //                 img.onload = () => {
      //                   resolve(img.width === 1080 && img.height === 1080);
      //                   URL.revokeObjectURL(objectUrl);
      //                 };
      //                 img.onerror = () => {
      //                   resolve(false);
      //                   URL.revokeObjectURL(objectUrl);
      //                 };
      //                 img.src = objectUrl;
      //               } else if (file.type === 'video') {
      //                 const video = document.createElement('video');
      //                 video.onloadedmetadata = () => {
      //                   resolve(
      //                     video.videoWidth === 1080 &&
      //                       video.videoHeight === 1080,
      //                   );
      //                   URL.revokeObjectURL(objectUrl);
      //                 };
      //                 video.onerror = () => {
      //                   resolve(false);
      //                   URL.revokeObjectURL(objectUrl);
      //                 };
      //                 video.src = objectUrl;
      //               } else {
      //                 resolve(false); // Unsupported file type
      //                 URL.revokeObjectURL(objectUrl);
      //               }
      //             });

      //             // Await the check and see if any file is invalid
      //             const isValid = await checkDimensions;
      //             if (!isValid) {
      //               isInvalid = true;
      //             }

      //             // If any file fails validation, set an error for the array
      //             if (isInvalid) {
      //               // Context is used to set the error for the entire array and not per file
      //               context.createError({
      //                 message: 'File dimensions must be 1080x1080.',
      //               });
      //             }
      //             return isValid;
      //           }
      //         },
      //       ),
      //   )
      //   .min(1, 'At least one file is required.')
      //   .max(4, 'You can upload a maximum of 4 files.'),

      files: Yup.array()
        .of(Yup.mixed<UploadedFileNew>().required('File is required'))
        .min(1, 'At least one file is required.'),
      // .max(4, 'You can upload a maximum of 4 files.'),

      commission_structure: Yup.mixed()
        .nullable()
        .test(
          'fileType',
          'Invalid file format. Only PDF files are allowed.',
          value => {
            if (!value) return true; // If no file is uploaded, it's valid because it's nullable
            const file = value as File; // Explicit cast
            return file.type === 'application/pdf';
          },
        ),
    }),
    onSubmit: async (values: any): Promise<void> => {
      console.log('🚀 ~ onSubmit: ~ values:', values);
      const payloadForDressCode: any = {};

      selectedOptions?.forEach((dress: any, index: any): any => {
        payloadForDressCode[`${index}`] = {id: dress.value};
      });

      console.log(values?.files, 'values files');
      // const files =  values?.files.map((file:any)=>{
      //   {id: file.id,sort_order:file.sort_order}

      // })

      // values?.files.map((file: any) => {
      //   // eslint-disable-next-line no-void
      //   return void replaceImageWithCropped(file);
      // });

      try {
        const formData = {
          event_name: values.event_name,
          main_artist_name: values.main_artist_name,
          other_artist_name: values.other_artist_name,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          status: values.status,
          table_booking_recipient_country_id: Number(values.country_code),
          table_booking_recipient:
            values?.table_booking_recipient !== undefined || null
              ? values?.table_booking_recipient
              : '',
          guest_status: values.guest_status,
          date_time: moment(values.date_time.replace('T', ' ')).format(
            'YYYY-MM-DD HH:mm',
          ),
          end_date: moment(values.end_date.replace('T', ' ')).format(
            'YYYY-MM-DD HH:mm',
          ),
          guest_close_date_time:
            values?.guest_close_date_time !== undefined ||
            values?.guest_close_date_time !== null
              ? moment(values?.guest_close_date_time?.replace('T', ' ')).format(
                  'YYYY-MM-DD HH:mm',
                )
              : '',
          venue_id: values.venue_id,
          address: values?.address,
          description: values?.description,
          dress_code_id: payloadForDressCode,
          age_policy: values?.age_policy,
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          ...(editEvent?.id ? {id: editEvent?.id} : {}),
          file:
            values?.files && typeof values.files !== 'string'
              ? values.files.map((file: any) => {
                  // If the file has an "id" key, remove "type" only
                  if (file.id) {
                    const {...rest} = file; // Destructure and exclude type
                    return rest; // Return the remaining properties without "type"
                  } else {
                    console.log(file, 'file---------------------');
                    // If the file doesn't have an "id" key, remove both "type" and "preview"
                    const {type, preview, ...rest} = file; // Destructure and exclude type and preview
                    return rest; // Return the remaining properties without "type" and "preview"
                  }
                })
              : '',
          // values?.files && typeof values.files !== 'string'
          //   ? values?.files
          //   : '',

          guest_max_capacity:
            values?.max_capacity !== undefined || null
              ? values?.max_capacity
              : '',
          priority_entry_rules:
            values?.priority_entry_rules !== undefined || null
              ? values?.priority_entry_rules
              : '',
          booking_status: values?.booking_status,
          weekday_discount:
            values?.weekday_discount !== undefined || null
              ? values?.weekday_discount
              : '',
          weekend_discount:
            values?.weekend_discount !== undefined || null
              ? values?.weekend_discount
              : '',
          table_max_capacity:
            values?.table_max_capacity !== undefined || null
              ? values?.table_max_capacity
              : '',
          commission_structure: values?.commission_structure ?? null,
          commission_structure_type: values?.commission_structure_type ?? null,
          type: values?.type_data ?? null,

          [type === 1 ? 'club_profile_id' : 'restaurant_profile_id']:
            values?.club_restaurant ?? null,
        };
        // console.log('🚀 ~ onSubmit: ~ formData:', formData);
        try {
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
          const response: any = editEvent?.id
            ? await ApiUtils.updateEvent(formData)
            : await ApiUtils.addEvent(formData);
          // eslint-disable-next-line @typescript-eslint/no-floating-promises, @typescript-eslint/strict-boolean-expressions
          if (setIsEditCategory) {
            setIsEditCategory((prev: boolean) => !prev);
          }
          if (setIsAddCategory) {
            setIsAddCategory((prev: boolean) => !prev);
          }
          handleClose();
          toast.success(response?.message);
          // void getCategoryList();
        } catch (error: any) {
          toast.error(error?.response?.data?.message);
        }
      } catch (err: any) {
        console.log(err, 'err divya');
        toast.error(err);
      }
    },
  });

  const getFileType = (
    input: File | string,
  ): 'image' | 'video' | 'unsupported' => {
    if (typeof input === 'string') {
      // Check for common image/video extensions in the URL
      if (/\.(jpg|jpeg|png|gif)$/i.test(input)) {
        return 'image';
      } else if (/\.(mp4|avi|mov|mkv)$/i.test(input)) {
        return 'video';
      } else {
        return 'unsupported';
      }
    } else if (input instanceof File) {
      const mimeType = input.type;
      if (mimeType.startsWith('image/')) {
        return 'image';
      } else if (mimeType.startsWith('video/')) {
        return 'video';
      } else {
        return 'unsupported';
      }
    }
    return 'unsupported'; // Fallback for unexpected cases
  };

  // const [fileType, setFileType] = useState<string>(
  //   getFileType(editEvent?.file),
  // );

  console.log(
    'FILE TYPE 1111',
    getFileType(editEvent?.file),
    typeof getFileType(editEvent?.file),
    editEvent?.file,
    // fileDisplay,
  );

  console.log('ERRORS:', validation.errors);

  // // Handle checkbox change
  // const handleCheckboxChange = (id: string): void => {
  //   setSelectedOptions((prev: any) => {
  //     if (prev.includes(id)) {
  //       // Remove if already selected
  //       return prev.filter((optionId: any) => optionId !== id);
  //     } else {
  //       // Add if not selected
  //       return [...prev, id];
  //     }
  //   });
  // };

  // // Get selected labels by their IDs
  // const selectedLabels = options
  //   .filter(option => selectedOptions.includes(option.id))
  //   .map(option => option.label);

  // const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>): void => {
  //   const file = e.target.files?.[0];
  //   if (file != null) {
  //     const objectUrl: string = URL.createObjectURL(file);
  //     const fileType = getFileType(file);

  //     switch (fileType) {
  //       case 'image':
  //         console.log('The uploaded file is an image.');
  //         // Handle image preview
  //         setFileType('image');
  //         break;
  //       case 'video':
  //         console.log('The uploaded file is a video.');
  //         // Handle video preview
  //         setFileType('video');
  //         break;
  //       default:
  //         console.log('Unsupported file type.');
  //         return;
  //     }

  //     setFileDisplay(objectUrl); // Update the state with the Blob URL
  //     validation.setFieldValue('file', file);
  //   }
  // };
  const handleDeleteFile = (): any => {
    setCommissionStructure(null);
    validation.setFieldValue('commission_structure', null);
    validation.setFieldValue('commission_structure_type', 'delete');
  };
  useEffect(() => {
    const fetchCategoryList = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.getVenueList('?type=AddEvent');
        console.log('🚀 ~ fetchCategoryList ~ response:', response);
        setCategoryList(response);
      } catch (err) {
        console.error(err);
      }
    };

    void fetchCategoryList();
  }, []);

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  const combinedStyles = (isDark: boolean, validation: any) => ({
    ...(isDark ? customStyles : {}), // Add dark mode styles if isDark is true
    control: (base: any, state: any) => ({
      ...base,
      backgroundColor: isDark ?? '#0f1f36', // Input background
      border: isDark ?? '2px solid #132846', // Custom border color and width
      borderColor:
        Boolean(validation.touched.dress_code_id) &&
        !(validation.errors.dress_code_id == null)
          ? 'red' // Red border for invalid
          : state.isFocused
            ? 'blue' // Blue border for focus
            : base.borderColor, // Default behavior
      '&:hover': {
        borderColor:
          Boolean(validation.touched.dress_code_id) &&
          !(validation.errors.dress_code_id == null)
            ? 'red'
            : state.isFocused
              ? 'blue'
              : base.borderColor,
      },
    }),
  });
  const [venueEdit, setVenueEdit] = useState<any>();

  const [clubList, setClubList] = useState<Club[]>([]);
  useEffect(() => {
    const fetchClubList = async (): Promise<void> => {
      try {
        const requestBody = {
          type: type == 1 ? 'club' : 'restaurant', // Add more fields as needed
          venue_id: [validation.values?.venue_id],
        };
        const response: any = await ApiUtils.getClub(requestBody);

        setClubList(response?.data);
      } catch (err) {
        console.error(err);
      }
    };
    // eslint-disable-next-line no-void
    type !== '' && void fetchClubList();
  }, [type, venueEdit]);
  // console.log(editEvent?.id, 'categoryList');
  useEffect(() => {
    if (!type) {
      setType(
        editEvent?.club_profile_id
          ? 1
          : editEvent?.restaurant_profile_id
            ? 2
            : '',
      );
    }
  }, [editEvent]);

  const countryCode = useSelector(
    (state: any) => state.commonState.countryCode,
  );

  useEffect(() => {
    const fetchCountryCode = async (): Promise<void> => {
      try {
        const response: any = await ApiUtils.getCountryCode();
        dispatch(setCountryCode(response?.data)); // Updates Redux store
      } catch (err) {
        console.error(err);
      }
    };

    if (!countryCode || countryCode.length === 0) {
      void fetchCountryCode();
    }
  }, [countryCode, dispatch]); // Re-run only if countryCode changes

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  function customFunction(phoneNumber: string, code: number) {
    const cleanedPhone = phoneNumber.replace(/\s+/g, '');

    // UAE landline area codes
    const landlineAreaCodes = ['2', '3', '4', '6', '7', '9'];

    // Check if UAE landline
    if (Number(code) === 971) {
      const areaCode = cleanedPhone.charAt(0);
      const isLandline =
        landlineAreaCodes.includes(areaCode) && /^\d{8}$/.test(cleanedPhone);

      if (isLandline) {
        console.log('📞 Validating as UAE landline:', isLandline);
        return true;
      }
    }

    // Use phone library for mobile or other countries
    const status = phone(`+${code} ${phoneNumber}`);
    console.log('📱 Validating with phone lib:', status);
    return status?.isValid;
  }

  useEffect(() => {
    if (validation?.values?.table_booking_recipient_country_id === undefined) {
      const country = countryCode.filter(
        (country: any) => country?.id == validation?.values?.country_code,
      );
      validation.setFieldValue('selected_country', country[0]);
    }
  }, [editEvent, validation?.values?.selected_country_code]);

  return (
    <div>
      <Form
        className="tablelist-form"
        onSubmit={e => {
          e.preventDefault();
          validation.handleSubmit();
        }}>
        <Row>
          <div
            id="alert-error-msg"
            className="d-none alert alert-danger py-2"></div>
          <input type="hidden" id="id-field" />
          {/* <Col
            lg={12}
            className="d-flex justify-content-center align-items-center">
            <div className="mb-3 category-img">
              <label
                htmlFor="category-image-input"
                className="form-label d-block text-center">
                Image / Video<span className="text-danger">*</span>
              </label>

              <div className="avatar-upload">
                <div className="avatar-edit">
                  <input
                    type="file"
                    id="imageUpload"
                    onChange={handleFileUpload}
                    accept=".png, .jpg, .jpeg, .mp4"
                  />
                  <label
                    htmlFor="imageUpload"
                    className="image-upload-cam d-flex justify-content-center align-items-center">
                    <i className="ri-image-fill"></i>
                  </label>
                </div>
                <div className="avatar-preview">
                  {fileType && fileType === 'image' && (
                    <img
                      height={'100px'}
                      src={
                        fileDisplay ??
                        (editEvent?.id && editEvent?.file !== ''
                          ? editEvent?.file
                          : categoryImagePlaceholder)
                      }
                      alt="Preview"
                    />
                  )}
                  {fileType && fileType === 'video' && (
                    <video
                      height={'100px'}
                      src={
                        fileDisplay ??
                        (editEvent?.id && editEvent?.file !== ''
                          ? editEvent?.file
                          : categoryImagePlaceholder)
                      }
                      controls
                    />
                  )}
                  {editEvent?.id === undefined && fileDisplay === undefined && (
                    <img height="100px" src={categoryImagePlaceholder} />
                  )}
                </div>
              </div>
              {Boolean(validation.touched.file) &&
              Boolean(validation.errors.file) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.file}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col> */}
          <Col lg={12} className="mb-3">
            <Row>
              <div>
                <h5>Add event images/videos:</h5>
                <FileUploader
                  onFilesAdded={handleFilesAdded}
                  accept={{
                    'image/*': ['.png', '.jpeg', '.jpg', '.gif'],
                    'video/*': ['.mp4', '.mov', '.avi'],
                  }}
                  multiple={true}
                  images={editEvent?.event_image}
                />
                {/* Validation Feedback */}
                {Boolean(validation.touched.files) &&
                  Boolean(validation.errors.files) && (
                    <Form.Control.Feedback
                      className="required-mark"
                      type="invalid">
                      {validation.errors.files}
                    </Form.Control.Feedback>
                  )}
                {/* <div style={{marginTop: '20px'}}>
                <h4>Files in Parent Component:</h4>
                {uploadedFiles.map((file, index) => (
                  <p key={index}>
                    {index + 1}. {file.file.name} ({file.type})
                  </p>
                ))}
              </div> */}
              </div>
            </Row>
          </Col>
          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="productType-field">Venue</Form.Label>
                <span className="text-danger required-mark">*</span>

                <TooltipWithInfoIcon text={tooltipMessage.SelectVenue} />
              </div>
              <Form.Select
                className="form-select"
                name="venue_id"
                id="productType-field"
                onChange={e => {
                  // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
                  const selectedVenue: any = categoryList.find(
                    // eslint-disable-next-line array-callback-return
                    (venue: CategoryDetailsTypes) =>
                      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
                      String(venue.id) == e.target.value,
                  );

                  setVenueEdit(e.target.value);

                  validation.setFieldValue('venue_id', e.target.value);
                  validation.setFieldValue(
                    'address',
                    selectedVenue?.address || '',
                  );
                }}
                value={
                  validation.values.venue_id ||
                  (editEvent?.venue_id !== '' ? editEvent?.venue_id : '')
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.venue_id) &&
                    Boolean(validation.errors.venue_id)
                  )
                }>
                <option value="">Select Venue</option>
                {categoryList?.map((data: CategoryDetailsTypes, i) => {
                  // Ensure the category name does not match the editEvent's name
                  if (editEvent?.event_name !== data.name) {
                    const categoryName = renderCategoryOptions(
                      data,
                      categoryList,
                      [],
                      editEvent?.event_name,
                    );

                    return (
                      <option value={data.id} key={i}>
                        {categoryName}
                      </option>
                    );
                  }
                  return null; // Avoid rendering anything if the condition is not met
                })}
              </Form.Select>
              {Boolean(validation.touched.venue_id) &&
              Boolean(validation.errors.venue_id) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.venue_id}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          {validation.values.venue_id && (
            <Col lg={12}>
              <div className="mb-3">
                <div className="d-flex">
                  <Form.Label htmlFor="productType-field">Type</Form.Label>
                  <TooltipWithInfoIcon text={tooltipMessage.type_data} />
                </div>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    name="type"
                    id={`type-club`}
                    value="club"
                    label="Club"
                    onChange={() => {
                      setType(1);
                      validation.setFieldValue('type_data', 1);
                      validation.setFieldValue('club_restaurant', '');
                    }}
                    checked={
                      validation.values.type_data === 1 ||
                      (editEvent?.type_data === 1 && true)
                    }
                    isInvalid={
                      !!(
                        validation.touched.type_data &&
                        validation.errors.type_data
                      )
                    }
                  />
                  <Form.Check
                    type="radio"
                    name="type"
                    id={`type-restaurant`}
                    value="restaurant"
                    label="Restaurant"
                    onChange={() => {
                      setType(2);
                      validation.setFieldValue('type_data', 2);
                      validation.setFieldValue('club_restaurant', '');
                    }}
                    checked={
                      validation.values.type_data === 2 ||
                      (editEvent?.type_data === 2 && true)
                    }
                    isInvalid={
                      !!(
                        validation.touched.type_data &&
                        validation.errors.type_data
                      )
                    }
                  />
                </div>

                {Boolean(validation.touched.type_data) &&
                Boolean(validation.errors.type_data) ? (
                  <Form.Control.Feedback
                    className="required-mark"
                    type="invalid">
                    {validation.errors.type_data}
                  </Form.Control.Feedback>
                ) : null}
              </div>
            </Col>
          )}
          {type != '' && validation.values.venue_id && (
            <Col lg={12}>
              <div className="mb-3">
                <div className="d-flex">
                  <Form.Label htmlFor="productType-field">
                    {type == 1 ? 'Club' : 'Restaurant'}
                  </Form.Label>
                  <TooltipWithInfoIcon text={tooltipMessage.club_restaurant} />
                </div>
                <Form.Select
                  className="form-select"
                  name="club_restaurant"
                  id={`club_restaurant`}
                  onChange={e => {
                    validation.setFieldValue('club_restaurant', e.target.value);
                  }}
                  value={
                    validation.values.club_restaurant ||
                    (editEvent?.club_restaurant !== ''
                      ? editEvent?.club_restaurant
                      : '')
                  }
                  isInvalid={
                    !!(
                      validation.touched.club_restaurant &&
                      validation.errors.club_restaurant
                    )
                  }>
                  <option value="">Select</option>
                  {clubList?.map((data: CategoryStatusList, i) => (
                    <option key={i} value={data.id}>
                      {data.name}
                    </option>
                  ))}
                </Form.Select>
                {Boolean(validation.touched.club_restaurant) &&
                Boolean(validation.errors.club_restaurant) ? (
                  <Form.Control.Feedback
                    className="required-mark"
                    type="invalid">
                    {validation.errors.club_restaurant}
                  </Form.Control.Feedback>
                ) : null}
              </div>
            </Col>
          )}

          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Event Name
                  <span className="text-danger required-mark">*</span>
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.EventName} />
              </div>
              <Form.Control
                type="text"
                id="event-name"
                placeholder="Enter Event Name"
                name="event_name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.event_name || editEvent?.event_name
                    ? editEvent?.event_name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.event_name) &&
                    Boolean(validation.errors.event_name)
                  )
                }
              />
              {Boolean(validation.touched.event_name) &&
              Boolean(validation.errors.event_name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.event_name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>
          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Main Artist Name
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.MainArtistName} />
              </div>
              <Form.Control
                type="text"
                id="event-name"
                placeholder="Enter Main Artist Name"
                name="main_artist_name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.main_artist_name ||
                  editEvent?.main_artist_name
                    ? editEvent?.main_artist_name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.main_artist_name) &&
                    Boolean(validation.errors.main_artist_name)
                  )
                }
              />
              {Boolean(validation.touched.main_artist_name) &&
              Boolean(validation.errors.main_artist_name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.main_artist_name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>
          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">
                  Other Artist Name
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.OtherArtistName} />
              </div>
              <Form.Control
                type="text"
                id="event-name"
                placeholder="Enter Other Artist Name"
                name="other_artist_name"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.other_artist_name ||
                  editEvent?.other_artist_name
                    ? editEvent?.other_artist_name
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.other_artist_name) &&
                    Boolean(validation.errors.other_artist_name)
                  )
                }
              />
              {Boolean(validation.touched.other_artist_name) &&
              Boolean(validation.errors.other_artist_name) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.other_artist_name}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          {/* <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                Event Date & Time{' '}
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.EventStartDate} />
              </div>
              <Form.Control
                type="datetime-local"
                id="date-time"
                name="date_time"
                min={new Date().toISOString().slice(0, 16)}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.date_time}
                isInvalid={
                  Boolean(validation.touched.date_time) &&
                  !(validation.errors.date_time == null)
                }
              />
              {Boolean(validation.touched.date_time) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.date_time as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col> */}

          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                Event Date & Time{' '}
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.EventStartDate} />
              </div>

              <Form.Control
                type="datetime-local"
                id="date-time"
                name="date_time"
                min={
                  validation.initialValues.date_time !==
                  validation.values.date_time
                    ? new Date().toISOString().slice(0, 16)
                    : undefined
                } // Apply `min` only if changed
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.date_time}
                isInvalid={
                  Boolean(validation.touched.date_time) &&
                  validation.initialValues.date_time !==
                    validation.values.date_time && // ✅ Only validate if changed
                  !(validation.errors.date_time == null)
                }
              />

              {Boolean(validation.touched.date_time) &&
                validation.initialValues.date_time !==
                  validation.values.date_time && (
                  <Form.Control.Feedback type="invalid">
                    {validation.errors.date_time as string}
                  </Form.Control.Feedback>
                )}
            </div>
          </Col>

          <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                Event End Date & Time{' '}
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.EventEndDate} />
              </div>
              <Form.Control
                type="datetime-local"
                id="end-date-time"
                name="end_date"
                min={new Date().toISOString().slice(0, 16)}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.end_date}
                isInvalid={
                  Boolean(validation.touched.date_time) &&
                  !(validation.errors.end_date == null)
                }
              />
              {Boolean(validation.touched.end_date) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.end_date as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          {/* <Col lg={4}>
            <div className="mb-3">
              <div className="d-flex">
                Guest list close time <span className="text-danger">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.GuestListCloseTime} />
              </div>
              <Form.Control
                type="datetime-local"
                id="guest-close-date-time"
                name="guest_close_date_time"
                min={new Date().toISOString().slice(0, 16)}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.guest_close_date_time}
                isInvalid={
                  Boolean(validation.touched.guest_close_date_time) &&
                  !(validation.errors.guest_close_date_time == null)
                }
              />
              {Boolean(validation.touched.guest_close_date_time) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.guest_close_date_time as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col> */}

          <Col lg={12}>
            <div aria-labelledby="category-name-label" className="mb-3">
              <div className="d-flex">
                <Form.Label id="category-name-label" htmlFor="category-name">
                  Dress Code
                </Form.Label>
                <TooltipWithInfoIcon text={tooltipMessage.DressCode} />
              </div>
              <Select
                isMulti
                className="custom-select"
                id="venue-name"
                name="dress_code_id"
                value={selectedOptions}
                onChange={handleSelectDressCodeChange}
                // styles={{
                //   control: (base: any, state: any) => ({
                //     ...base,
                //     borderColor:
                //       Boolean(validation.touched.dress_code_id) &&
                //       !(validation.errors.dress_code_id == null)
                //         ? 'red' // Red border for invalid
                //         : state.isFocused
                //           ? 'blue' // Custom border for focus
                //           : base.borderColor, // Default behavior
                //     '&:hover': {
                //       borderColor:
                //         Boolean(validation.touched.dress_code_id) &&
                //         !(validation.errors.dress_code_id == null)
                //           ? 'red'
                //           : state.isFocused
                //             ? 'blue'
                //             : base.borderColor,
                //     },
                //   }),
                // }}
                styles={combinedStyles(isDark, validation)}
                options={options}></Select>
            </div>
            {Boolean(validation.touched.dress_code_id) && (
              <Form.Control.Feedback type="invalid">
                {validation.errors.dress_code_id as string}
              </Form.Control.Feedback>
            )}
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">
                  Guest List Status
                </Form.Label>
                <span className="text-danger required-mark">*</span>

                <TooltipWithInfoIcon text={tooltipMessage.EventStatus} />
              </div>

              <Form.Select
                className="form-select"
                name="guest_status"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('guest_status', e.target.value)
                }
                value={
                  validation.values.guest_status ||
                  (editEvent?.guest_status !== ''
                    ? editEvent?.guest_status
                    : '')
                }
                isInvalid={
                  !!(
                    validation.touched.guest_status &&
                    validation.errors.guest_status
                  )
                }>
                <option value="">Guest Status</option>
                {guestListStatus?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.guest_status) &&
              Boolean(validation.errors.guest_status) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.guest_status}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          {/* Conditionally render Guest Close Time */}
          {validation.values.guest_status &&
            parseInt(validation.values.guest_status) === 1 && (
              <>
                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Guest list close time{' '}
                        <span className="text-danger required-mark">*</span>
                      </Form.Label>
                      <TooltipWithInfoIcon
                        text={tooltipMessage.GuestListCloseTime}
                      />
                    </div>
                    <Form.Control
                      type="datetime-local"
                      id="guest-close-date-time"
                      name="guest_close_date_time"
                      min={new Date().toISOString().slice(0, 16)}
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.guest_close_date_time}
                      isInvalid={
                        Boolean(validation.touched.guest_close_date_time) &&
                        !(validation.errors.guest_close_date_time == null)
                      }
                    />
                    {Boolean(validation.touched.guest_close_date_time) && (
                      <Form.Control.Feedback type="invalid">
                        {validation.errors.guest_close_date_time as string}
                      </Form.Control.Feedback>
                    )}
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Guest max capacity(people)
                        <span className="text-danger required-mark">*</span>
                      </Form.Label>

                      <TooltipWithInfoIcon text={tooltipMessage.MaxCapacity} />
                    </div>
                    <Form.Control
                      type="number"
                      id="max_capacity"
                      placeholder="Enter Guest  Max Capacity"
                      name="max_capacity"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.max_capacity ||
                        editEvent?.guest_max_capacity
                          ? editEvent?.guest_max_capacity
                          : ''
                      }
                      isInvalid={
                        !!(
                          Boolean(validation.touched.max_capacity) &&
                          Boolean(validation.errors.max_capacity)
                        )
                      }
                      onWheel={e => {
                        e.currentTarget.blur();
                      }} // Prevent mouse wheel input
                    />
                    {Boolean(validation.touched.max_capacity) && (
                      <Form.Control.Feedback type="invalid">
                        {validation.errors.max_capacity as string}
                      </Form.Control.Feedback>
                    )}
                  </div>
                </Col>

                <Col lg={12}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Priority Entry Rules
                        {/* <span className="text-danger required-mark">*</span> */}
                      </Form.Label>

                      <TooltipWithInfoIcon
                        text={tooltipMessage.priorityEntryRules}
                      />
                    </div>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      id="priority_entry_rules"
                      placeholder="Enter Priority Entry Rules"
                      name="priority_entry_rules"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.priority_entry_rules ||
                        editEvent?.priority_entry_rules
                          ? editEvent?.priority_entry_rules
                          : ''
                      }
                      isInvalid={
                        !!(
                          Boolean(validation.touched.priority_entry_rules) &&
                          Boolean(validation.errors.priority_entry_rules)
                        )
                      }
                    />
                    {Boolean(validation.touched.priority_entry_rules) && (
                      <Form.Control.Feedback type="invalid">
                        {validation.errors.priority_entry_rules as string}
                      </Form.Control.Feedback>
                    )}
                  </div>
                </Col>
              </>
            )}

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="booking_status">Booking Status</Form.Label>
                <span className="text-danger required-mark">*</span>

                <TooltipWithInfoIcon text={tooltipMessage.EventStatus} />
              </div>

              <Form.Select
                className="form-select"
                name="booking_status"
                id="booking_status"
                onChange={e =>
                  validation.setFieldValue('booking_status', e.target.value)
                }
                value={
                  validation.values.booking_status ||
                  (editEvent?.booking_status !== ''
                    ? editEvent?.booking_status
                    : '')
                }
                isInvalid={
                  !!(
                    validation.touched.booking_status &&
                    validation.errors.booking_status
                  )
                }>
                <option value="">Booking Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.booking_status) &&
              Boolean(validation.errors.booking_status) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.booking_status}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          {/* Conditionally render Guest Close Time */}
          {validation.values.booking_status &&
            parseInt(validation.values.booking_status) === 1 && (
              <>
                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Weekday Discount %
                        <span className="text-danger required-mark">*</span>
                      </Form.Label>

                      <TooltipWithInfoIcon
                        text={tooltipMessage.weekdayDiscount}
                      />
                    </div>
                    <Form.Control
                      type="number"
                      id="weekday_discount"
                      placeholder="Enter Weekday Discount"
                      name="weekday_discount"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.weekday_discount ||
                        editEvent?.weekday_discount
                          ? editEvent?.weekday_discount
                          : ''
                      }
                      isInvalid={
                        !!(
                          Boolean(validation.touched.weekday_discount) &&
                          Boolean(validation.errors.weekday_discount)
                        )
                      }
                      onWheel={e => {
                        e.currentTarget.blur();
                      }} // Prevent mouse wheel input
                    />
                    {Boolean(validation.touched.weekday_discount) && (
                      <Form.Control.Feedback type="invalid">
                        {validation.errors.weekday_discount as string}
                      </Form.Control.Feedback>
                    )}
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Weekend Discount %
                        <span className="text-danger required-mark">*</span>
                      </Form.Label>

                      <TooltipWithInfoIcon
                        text={tooltipMessage.weekendDiscount}
                      />
                    </div>
                    <Form.Control
                      type="number"
                      id="weekend_discount"
                      placeholder="Enter Weekend Discount"
                      name="weekend_discount"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.weekend_discount ||
                        editEvent?.weekend_discount
                          ? editEvent?.weekend_discount
                          : ''
                      }
                      isInvalid={
                        !!(
                          Boolean(validation.touched.weekend_discount) &&
                          Boolean(validation.errors.weekend_discount)
                        )
                      }
                      onWheel={e => {
                        e.currentTarget.blur();
                      }} // Prevent mouse wheel input
                    />
                    {Boolean(validation.touched.weekend_discount) && (
                      <Form.Control.Feedback type="invalid">
                        {validation.errors.weekend_discount as string}
                      </Form.Control.Feedback>
                    )}
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <div className="d-flex">
                      <Form.Label htmlFor="category-name">
                        Table max capacity(people)
                        <span className="text-danger required-mark">*</span>
                      </Form.Label>

                      <TooltipWithInfoIcon
                        text={tooltipMessage.TableMaxCapacity}
                      />
                    </div>
                    <Form.Control
                      type="number"
                      id="table_max_capacity"
                      placeholder="Enter Table Max Capacity"
                      name="table_max_capacity"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      defaultValue={
                        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                        validation?.values?.table_max_capacity ||
                        editEvent?.table_max_capacity
                          ? editEvent?.table_max_capacity
                          : ''
                      }
                      isInvalid={
                        !!(
                          Boolean(validation.touched.table_max_capacity) &&
                          Boolean(validation.errors.table_max_capacity)
                        )
                      }
                      onWheel={e => {
                        e.currentTarget.blur();
                      }} // Prevent mouse wheel input
                    />
                    {Boolean(validation.touched.table_max_capacity) && (
                      <Form.Control.Feedback type="invalid">
                        {validation.errors.table_max_capacity as string}
                      </Form.Control.Feedback>
                    )}
                  </div>
                </Col>
                <Col lg={6}> </Col>
              </>
            )}

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="status-Field">Status</Form.Label>
                <span className="text-danger required-mark">*</span>

                <TooltipWithInfoIcon text={tooltipMessage.EventStatus} />
              </div>

              <Form.Select
                className="form-select"
                name="status"
                id="status-Field"
                onChange={e =>
                  validation.setFieldValue('status', e.target.value)
                }
                value={
                  validation.values.status ||
                  (editEvent?.status !== '' ? editEvent?.status : '')
                }
                isInvalid={
                  !!(validation.touched.status && validation.errors.status)
                }>
                <option value="">Status</option>
                {status?.map((data: CategoryStatusList, i) => (
                  <option key={i} value={data.id}>
                    {data.name}
                  </option>
                ))}
              </Form.Select>

              {Boolean(validation.touched.status) &&
              Boolean(validation.errors.status) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.status}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="category-name">Age Policy</Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.AgePolicy} />
              </div>
              <Form.Control
                type="text"
                id="event-name"
                placeholder="Enter age policy"
                name="age_policy"
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                defaultValue={
                  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                  validation?.values?.age_policy || editEvent?.age_policy
                    ? editEvent?.age_policy
                    : ''
                }
                isInvalid={
                  !!(
                    Boolean(validation.touched.age_policy) &&
                    Boolean(validation.errors.age_policy)
                  )
                }
              />
              {Boolean(validation.touched.age_policy) &&
              Boolean(validation.errors.age_policy) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.age_policy}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                Event Address{' '}
                <span className="text-danger required-mark">*</span>
                <TooltipWithInfoIcon text={tooltipMessage.EventAddress} />
              </div>
              <Form.Control
                as="textarea"
                id="address"
                name="address"
                rows={4}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.address}
                isInvalid={
                  Boolean(validation.touched.address) &&
                  !(validation.errors.address == null)
                }
              />
              {Boolean(validation.touched.address) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.address as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          <Col lg={12}>
            <div className="mb-3">
              <div className="d-flex">
                Description
                {/* <span className="text-danger">*</span> */}
                <TooltipWithInfoIcon text={tooltipMessage.EventDescription} />
              </div>
              <Form.Control
                as="textarea"
                id="description"
                name="description"
                rows={4}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                value={validation.values.description}
                isInvalid={
                  Boolean(validation.touched.description) &&
                  !(validation.errors.description == null)
                }
              />
              {Boolean(validation.touched.description) && (
                <Form.Control.Feedback type="invalid">
                  {validation.errors.description as string}
                </Form.Control.Feedback>
              )}
            </div>
          </Col>

          <Col lg={6}>
            <div className="mb-3">
              <div className="d-flex">
                <Form.Label htmlFor="commission_structure">
                  Commission Structure
                </Form.Label>

                <TooltipWithInfoIcon text={tooltipMessage.EventStatus} />
              </div>

              <Form.Control
                type="file"
                accept="application/pdf"
                id="commission_structure"
                name="commission_structure"
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  const file = event.currentTarget.files?.[0] ?? null;
                  setCommissionStructure(null);
                  validation.setFieldValue('commission_structure', file);
                }}
                isInvalid={
                  !!(
                    Boolean(validation.touched.commission_structure) &&
                    Boolean(validation.errors.commission_structure)
                  )
                }
              />

              {Boolean(validation.touched.commission_structure) &&
              Boolean(validation.errors.commission_structure) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.commission_structure}
                </Form.Control.Feedback>
              ) : null}
            </div>
          </Col>

          {validation.values.booking_status == 1 && (
            <Col lg={6}>
              <div className="d-flex">
                <Form.Label htmlFor="table_booking_recipient">
                  Booking recipient
                  <span className="text-danger required-mark">*</span>
                </Form.Label>
              </div>

              <div className="mb-1 d-flex">
                <Form.Select
                  className="form-select"
                  style={{width: 'fit-content'}}
                  name="country_code"
                  id="country_code"
                  value={
                    validation.values.country_code ||
                    (validation?.table_booking_recipient_country_id !== ''
                      ? validation?.table_booking_recipient_country_id
                      : '')
                  }
                  onChange={e => {
                    const selectedId = e.target.value;
                    const selectedOption =
                      e.target.options[e.target.selectedIndex];

                    validation.setFieldValue('country_code', selectedId);
                    validation.setFieldValue(
                      'selected_country_code',
                      selectedOption.getAttribute('data-country-code'),
                    );
                  }}>
                  {countryCode?.map(
                    (
                      data: {
                        id: string;
                        name: string;
                        short_code: string;
                        country_code: number;
                      },
                      i: React.Key | null | undefined,
                    ) => (
                      <option
                        key={i}
                        value={data.id}
                        data-country-code={data.country_code}>
                        {data.short_code} (+{data.country_code})
                      </option>
                    ),
                  )}
                </Form.Select>

                <Form.Control
                  type="number"
                  id="table-booking-recipient"
                  placeholder="Enter phone number"
                  name="table_booking_recipient"
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  defaultValue={
                    validation?.values?.table_booking_recipient ||
                    editEvent?.table_booking_recipient
                      ? editEvent?.table_booking_recipient
                      : ''
                  }
                  isInvalid={
                    !!(
                      Boolean(validation.touched.table_booking_recipient) &&
                      Boolean(validation.errors.table_booking_recipient)
                    )
                  }
                  onWheel={e => {
                    e.currentTarget.blur();
                  }}
                />
              </div>

              {Boolean(validation.touched.table_booking_recipient) &&
              Boolean(validation.errors.table_booking_recipient) ? (
                <Form.Control.Feedback className="required-mark" type="invalid">
                  {validation.errors.table_booking_recipient}
                </Form.Control.Feedback>
              ) : null}
            </Col>
          )}

          {commissionStructure !== null || commissionStructure !== undefined ? (
            <Col lg={6}>
              <div>
                {commissionStructure ? (
                  <div className="mt-4">
                    <a
                      href={commissionStructure}
                      target="_blank"
                      rel="noopener noreferrer">
                      View Commission Structure PDF
                    </a>
                    <button
                      className="btn btn-sm btn-danger mx-2"
                      onClick={handleDeleteFile}>
                      <i className="ri-delete-bin-fill align-bottom  text-muted" />
                    </button>
                  </div>
                ) : null}
              </div>
            </Col>
          ) : null}
          <Col lg={12} className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <Button
                role="submitCategory"
                variant="dark"
                id="add-btn"
                type="submit">
                {editEvent?.id !== undefined ? 'Edit Event' : 'Add Event'}
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default EventForm;
